import { useEffect, useMemo } from 'react'
import { FC } from "react";
import useNcId from 'application/hooks/useNcId';
import Glide from "@glidejs/glide";
import NextPrev from 'shared/NextPrev/NextPrev';
import Heading from 'shared/Heading/Heading';
import { useTranslation } from 'react-i18next'

import partner1 from "images/partners/partner1.png";
import partner2 from "images/partners/partner2.png";
import partner3 from "images/partners/partner3.png";
import partner4 from "images/partners/partner4.png";
import partner5 from "images/partners/partner5.png";
import partner6 from "images/partners/cna_pisa.png";
import partner7 from "images/partners/comune_alcaralifusi.png";
import partner8 from "images/partners/inesto.png";
import partner9 from "images/partners/parco_arcipelago_toscano.png";


export interface SectionPartnersProps {
    className?: string;
}

const PARTNERS = [
    { id: 1, img: partner1, name: "Partner 1" },
    { id: 2, img: partner2, name: "Partner 2" },
    { id: 3, img: partner3, name: "Partner 3" },
    { id: 4, img: partner4, name: "Partner 4" },
    { id: 5, img: partner5, name: "Partner 5" },
    { id: 6, img: partner6, name: "Partner 6" },
    { id: 7, img: partner7, name: "Partner 7" },
    { id: 8, img: partner8, name: "Partner 8" },
    { id: 9, img: partner9, name: "Partner 9" },
]

const SectionPartners: FC<SectionPartnersProps> = ({
    className = "",
}) => {

    const { t, ready } = useTranslation("translation");

    const UNIQUE_CLASS = `partnerSlider` + useNcId();

    let MY_GLIDEJS = useMemo(() => {
        return new Glide(`.${UNIQUE_CLASS}`, {
            perView: 5,
            gap: 0,
            keyboard: false,
            rewind: true,
            type: "carousel",
            breakpoints: {
                1024: {
                    perView: 4,
                },
                768: {
                    perView: 3,
                },
                640: {
                    perView: 2,
                },
                480: {
                    perView: 1,
                },
            },
        });
    }, [UNIQUE_CLASS]);

    useEffect(() => {
        setTimeout(() => {
            try {
                MY_GLIDEJS.mount();
            }
            catch (error) {
                console.error("Error on mounting glide", error);
            }
        }, 200);

    }, [MY_GLIDEJS,]);

    if (!ready) return null;

    return (
        <div>
            <Heading desc={t("translation:components.sectionPartners.description")} className='m-0'>
                {t("translation:components.sectionPartners.heading")}
            </Heading>
            <div className={`${UNIQUE_CLASS} relative group overflow-hidden`}>
                <div className="glide__track" data-glide-el="track">
                    <ul className="glide__slides">
                        {PARTNERS.map((item, index) => (
                            <li key={index} className="glide__slide">
                                <div className={`flex items-center h-auto lg:h-[17rem] w-full`}>
                                    <img src={item.img} alt={`partner ${index} logo`}/>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="absolute opacity-0 group-hover:opacity-100 transition-opacity flex top-1/2 transform -translate-y-1/2 inset-x-2 justify-between">
                    <NextPrev className="w-full justify-between" btnClassName="w-8 h-8" />
                </div>
            </div>
        </div>

    );
};

export default SectionPartners;
